import React from 'react';

import {useAppSelector} from 'store/config/hooks';
import {
    selectTableReportHeaders,
    selectTableReportTemplateName,
} from 'store/slices/table-report-slice/table-report-slice-selectors';

import {EDesignTemplates} from '../../table-report-types';
import {DefaultHeader} from './headers/default-header/default-header';
import {FilterHeader} from './headers/filter-header';
import {RowOutputHeader} from './headers/row-output-header/row-output-header';
import {CollapsibleHeader} from './hocs/collapsible-header';
import {shouldRenderHeader} from './table-report-header.utils';

interface ITableReportHeaderProps {
    designTemplate?: string;
}

export const TableReportHeader = ({designTemplate}: ITableReportHeaderProps) => {
    const headers = useAppSelector(selectTableReportHeaders);
    const templateName = useAppSelector(selectTableReportTemplateName);

    const name = headers?.name?.value ?? templateName;

    if (!name) return null;

    return (
        <>
            <CollapsibleHeader
                reportName={name}
                designTemplate={designTemplate}
            >
                {(() => {
                    if (!shouldRenderHeader(designTemplate, headers)) return null;

                    switch (designTemplate) {
                    case EDesignTemplates.DECLARATION:
                    case EDesignTemplates.REGISTERS:
                        return (
                            <DefaultHeader
                                headers={headers}
                            />
                        );
                    case EDesignTemplates.TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER:
                    case EDesignTemplates.TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER_AND_HEADER:
                        return <FilterHeader />;
                    case EDesignTemplates.POSTING_CARD:
                    case EDesignTemplates.REGISTER_WITH_ROW_HEADERS:
                        return (
                            <RowOutputHeader
                                headers={headers}
                            />
                        );
                    default:
                        return null;
                    }
                })()}
            </CollapsibleHeader>

            {designTemplate === EDesignTemplates.TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER_AND_HEADER
              && headers
              && (
                  <RowOutputHeader
                      headers={headers}
                  />
              )}
        </>

    );
};
